import { render, staticRenderFns } from "./PhotoActionsPopover.vue?vue&type=template&id=6cc5153c&"
import script from "./PhotoActionsPopover.vue?vue&type=script&lang=js&"
export * from "./PhotoActionsPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports